// import React, { useState, useEffect } from "react";
// import { FaFileInvoice, FaPencilAlt, FaTrash } from "react-icons/fa";

// const MasterGst = () => {
//   const [gstEntries, setGstEntries] = useState([]);
//   const [form, setForm] = useState({ id: null, cgst: "", igst: "", sgst: "" });
//   const [isEditing, setIsEditing] = useState(false);
//   const [error, setError] = useState("");
//   const API_BASE = "https://cloudapi.emedhatechnologies.com/pages/api/api/gst"; // ✅ Change to your backend port

//   // ✅ Get user id from sessionStorage

//   const user = JSON.parse(sessionStorage.getItem("userData"));
//   const userId = user.type === "employee" ? user.parent_company_id : user.id;
//   const currentUserId = user.id;

//   // ✅ Fetch GST entries from backend
//   useEffect(() => {
//     if (!userId) return;
//     fetch(API_BASE, {
//       headers: {
//         "x-user-id": userId,
//       },
//     })
//       .then((res) => res.json())
//       .then(setGstEntries)
//       .catch((err) => console.error("Error fetching GST entries:", err));
//   }, [userId]);

//   // ✅ Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
//       setForm((prev) => ({ ...prev, [name]: value }));
//       setError("");
//     } else {
//       setError("Values must be between 0 and 100");
//     }
//   };

//   // ✅ Handle submit (Add / Update)
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!userId) {
//       setError("User not logged in.");
//       return;
//     }

//     // Basic validation
//     if (!form.cgst || !form.sgst || !form.igst) {
//       setError("All fields are required");
//       return;
//     }

//     const method = isEditing ? "PUT" : "POST";
//     const url = isEditing ? `${API_BASE}/${form.id}` : API_BASE;

//     try {
//       const res = await fetch(url, {
//         method,
//         headers: {
//           "Content-Type": "application/json",
//           "x-user-id": userId,
//           "x-user": currentUserId
//         },
//         body: JSON.stringify({
//           cgst: Number(form.cgst),
//           sgst: Number(form.sgst),
//           igst: Number(form.igst),
//         }),
//       });

//       if (!res.ok) {
//         const errData = await res.json();
//         throw new Error(errData.error || "Failed to save GST entry");
//       }

//       const data = await res.json();

//       if (isEditing) {
//         // Update locally
//         setGstEntries((prev) =>
//           prev.map((item) => (item.id === form.id ? data : item))
//         );
//         setIsEditing(false);
//       } else {
//         // Add new
//         setGstEntries((prev) => [...prev, data]);
//       }

//       setForm({ id: null, cgst: "", sgst: "", igst: "" });
//       setError("");
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // ✅ Handle edit
//   const handleEdit = (id) => {
//     const entry = gstEntries.find((item) => item.id === id);
//     if (entry) {
//       setForm(entry);
//       setIsEditing(true);
//     }
//   };

//   // ✅ Handle delete
//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure to delete this entry?")) return;

//     try {
//       const res = await fetch(`${API_BASE}/${id}`, {
//         method: "DELETE",
//         headers: {
//           "x-user-id": userId,
//         },
//       });

//       if (!res.ok) throw new Error("Failed to delete GST entry");

//       setGstEntries((prev) => prev.filter((item) => item.id !== id));

//       if (isEditing && form.id === id) {
//         setForm({ id: null, cgst: "", sgst: "", igst: "" });
//         setIsEditing(false);
//       }
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   return (
//     <>
//       <div style={{ minHeight: "100vh", fontFamily: "Arial, sans-serif", color: "#222", }}>
//         <h2 style={{ textAlign: "left", color: "#273179", fontWeight: "700", marginBottom: "15px", }}>
//           <FaFileInvoice style={{ marginRight: "8px" }} /> Master GST
//         </h2>

//         {/* Form */}
//         <div style={{ background: "#fff", padding: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", marginBottom: "20px", borderRadius: "8px", }}>
//           <form onSubmit={handleSubmit} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "20px", alignItems: "center", }} noValidate>
//             {["cgst", "sgst", "igst"].map((tax) => (
//               <div key={tax} style={{ display: "flex", flexDirection: "column" }}>
//                 <label htmlFor={tax} style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>
//                   {tax.toUpperCase()} (%)
//                 </label>
//                 <input type="number" id={tax} name={tax} value={form[tax]} onChange={handleChange} placeholder={`Enter ${tax.toUpperCase()} %`} style={{ padding: "8px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "6px", }} />
//               </div>
//             ))}

//             <button type="submit" style={{ padding: "10px", background: isEditing ? "#E53E3E" : "#3182CE", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", width: "80px", height: "40px", alignSelf: "end", }}>
//               {isEditing ? "Update" : "Add"}
//             </button>
//           </form>
//         </div>

//         {error && (
//           <p style={{ color: "red", textAlign: "center", marginTop: "10px" }}>{error}</p>
//         )}

//         {/* Responsive Table */}
//         <div style={{ background: "#fff", padding: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", borderRadius: "8px", overflowX: "auto", }}>
//           <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", minWidth: "300px", }}>
//             <thead>
//               <tr style={{ backgroundColor: "#f9f9f9" }}>
//                 <th style={{ textAlign: "left", padding: "10px", borderBottom: "2px solid #ddd", }}>CGST (%)</th>
//                 <th style={{ textAlign: "left", padding: "10px", borderBottom: "2px solid #ddd", }}>SGST (%)</th>
//                 <th style={{ textAlign: "left", padding: "10px", borderBottom: "2px solid #ddd", }}>IGST (%)</th>
//                 <th style={{ textAlign: "center", padding: "10px", borderBottom: "2px solid #ddd", }}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {gstEntries.map(({ id, cgst, sgst, igst }) => (
//                 <tr key={id}>
//                   <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>{parseFloat(cgst).toFixed(2)}</td>
//                   <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>{parseFloat(sgst).toFixed(2)}</td>
//                   <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>{parseFloat(igst).toFixed(2)}</td>
//                   <td style={{ padding: "10px", borderBottom: "1px solid #eee", textAlign: "center", whiteSpace: "nowrap", }}>
//                     <button onClick={() => handleEdit(id)} style={{ backgroundColor: "#007bff", color: "white", border: "none", padding: "6px 10px", borderRadius: "4px", marginRight: "6px", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", }}><FaPencilAlt /></button>
//                     <button onClick={() => handleDelete(id)} style={{ backgroundColor: "#dc3545", color: "white", border: "none", padding: "6px 10px", borderRadius: "4px", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", }}><FaTrash /></button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//     </>
//   );
// };

// export default MasterGst;



// import React, { useState, useEffect } from 'react';
// import { Plus, Search, Filter, Edit, Trash2, Percent, X, ChevronLeft, ChevronRight } from 'lucide-react';

// const initialGstData = [
//   { id: 'GST-001', name: 'CGST @ 9%', cgst: '9%', sgst: '0%', igst: '0%', applicableOn: 'Goods & Services', status: 'Active', createdDate: '2024-01-10' },
//   { id: 'GST-002', name: 'SGST @ 9%', cgst: '0%', sgst: '9%', igst: '0%', applicableOn: 'Goods & Services', status: 'Active', createdDate: '2024-01-10' },
//   { id: 'GST-003', name: 'IGST @ 18%', cgst: '0%', sgst: '0%', igst: '18%', applicableOn: 'Interstate Sales', status: 'Active', createdDate: '2024-01-10' },
// ];

// // Fallback theme colors approximating standard shadcn/tailwind templates
// const theme = {
//   background: '#f9fafb',
//   foreground: '#111827',
//   card: '#ffffff',
//   border: '#e5e7eb',
//   muted: '#f3f4f6',
//   mutedForeground: '#6b7280',
//   primary: '#1f2937',
//   primaryForeground: '#ffffff',
//   blue: '#2563eb',
//   green: '#16a34a',
//   purple: '#9333ea',
//   red: '#ef4444',
//   redBg: '#fef2f2'
// };

// const MasterGst = () => {
//   const [data, setData] = useState(initialGstData);
//   const [searchTerm, setSearchTerm] = useState('');
  
//   // Pagination State
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;
  
//   // CRUD Modal states
//   const [isOpen, setIsOpen] = useState(false);
//   const [isEdit, setIsEdit] = useState(false);
//   const [currentId, setCurrentId] = useState('');
  
//   // Form states
//   const [cgst, setCgst] = useState('');
//   const [sgst, setSgst] = useState('');
//   const [igst, setIgst] = useState('');

//   // Handle responsiveness via JS window state since pure inline styles can't use media queries
//   const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const isMobile = windowWidth < 768; // md breakpoint
//   const isTablet = windowWidth < 1024; // lg breakpoint

//   const handleOpenAdd = () => {
//     setIsEdit(false);
//     setCgst('');
//     setSgst('');
//     setIgst('');
//     setIsOpen(true);
//   };

//   const handleOpenEdit = (item) => {
//     setIsEdit(true);
//     setCurrentId(item.id);
//     setCgst(item.cgst.replace('%', ''));
//     setSgst(item.sgst.replace('%', ''));
//     setIgst(item.igst.replace('%', ''));
//     setIsOpen(true);
//   };

//   const handleDelete = (id) => {
//     const updatedData = data.filter(item => item.id !== id);
//     setData(updatedData);
//     const totalPages = Math.ceil(updatedData.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) {
//       setCurrentPage(totalPages);
//     }
//   };

//   const handleSave = (e) => {
//     e.preventDefault();
    
//     let generatedName = '';
//     if (igst && parseFloat(igst) > 0) {
//       generatedName = `IGST @ ${igst}%`;
//     } else if (cgst && sgst && parseFloat(cgst) > 0 && parseFloat(sgst) > 0) {
//       generatedName = `CGST & SGST @ ${cgst}%`;
//     } else if (cgst && parseFloat(cgst) > 0) {
//       generatedName = `CGST @ ${cgst}%`;
//     } else if (sgst && parseFloat(sgst) > 0) {
//       generatedName = `SGST @ ${sgst}%`;
//     } else {
//       generatedName = 'GST @ 0%';
//     }

//     if (isEdit) {
//       setData(data.map(item => item.id === currentId ? {
//         ...item,
//         name: generatedName,
//         cgst: `${cgst || 0}%`,
//         sgst: `${sgst || 0}%`,
//         igst: `${igst || 0}%`
//       } : item));
//     } else {
//       const newId = `GST-${String(data.length + 1).padStart(3, '0')}`;
//       const newItem = {
//         id: newId,
//         name: generatedName,
//         cgst: `${cgst || 0}%`,
//         sgst: `${sgst || 0}%`,
//         igst: `${igst || 0}%`,
//         applicableOn: 'Goods & Services',
//         status: 'Active',
//         createdDate: new Date().toISOString().split('T')[0]
//       };
//       setData([...data, newItem]);
//       setCurrentPage(Math.ceil((data.length + 1) / itemsPerPage));
//     }
//     setIsOpen(false);
//   };

//   // Filter & Pagination Math Logic
//   const filteredData = data.filter(item =>
//     item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     item.id.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

//   return (
//     <div style={{ padding: isTablet ? '1rem' : '2rem', display: 'flex', flexDirection: 'column', gap: '1.5rem', backgroundColor: theme.background, minHeight: '100vh', color: theme.foreground, fontFamily: 'sans-serif' }}>
      
//       {/* Header section */}
//       <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'space-between', gap: '1rem' }}>
//         <div>
//           <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', letterSpacing: '-0.025em', margin: 0, color: theme.foreground }}>GST Master</h1>
//           <p style={{ color: theme.mutedForeground, fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>Manage GST rates and configurations</p>
//         </div>
//         <button 
//           onClick={handleOpenAdd}
//           style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', backgroundColor: theme.primary, color: theme.primaryForeground, border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontSize: '0.875rem', width: isMobile ? '100%' : 'auto', justifyContent: 'center' }}
//         >
//           <Plus style={{ width: '1rem', height: '1rem' }} /> Add GST Rate
//         </button>
//       </div>

//       {/* Stats Cards */}
//       <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, minmax(0, 1fr))' : isTablet ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))', gap: '1rem' }}>
//         <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//           <p style={{ color: theme.mutedForeground, fontSize: '0.75rem', fontWeight: 500, textTransform: 'uppercase', tracking: '0.05em', margin: '0 0 0.25rem 0' }}>Total GST Rates</p>
//           <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>{data.length}</h3>
//         </div>
//         <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//           <p style={{ color: theme.mutedForeground, fontSize: '0.75rem', fontWeight: 500, textTransform: 'uppercase', tracking: '0.05em', margin: '0 0 0.25rem 0' }}>CGST Items</p>
//           <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0, color: theme.blue }}>{data.filter(i => parseFloat(i.cgst) > 0).length}</h3>
//         </div>
//         <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//           <p style={{ color: theme.mutedForeground, fontSize: '0.75rem', fontWeight: 500, textTransform: 'uppercase', tracking: '0.05em', margin: '0 0 0.25rem 0' }}>SGST Items</p>
//           <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0, color: theme.green }}>{data.filter(i => parseFloat(i.sgst) > 0).length}</h3>
//         </div>
//         <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//           <p style={{ color: theme.mutedForeground, fontSize: '0.75rem', fontWeight: 500, textTransform: 'uppercase', tracking: '0.05em', margin: '0 0 0.25rem 0' }}>IGST Items</p>
//           <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0, color: theme.purple }}>{data.filter(i => parseFloat(i.igst) > 0).length}</h3>
//         </div>
//       </div>

//       {/* Filters input row */}
//       <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '0.75rem', alignItems: 'center' }}>
//         <div style={{ flex: 1, width: '100%', position: 'relative' }}>
//           <Search style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', width: '1rem', height: '1rem', color: theme.mutedForeground }} />
//           <input
//             type="text"
//             placeholder="Search GST rates..."
//             value={searchTerm}
//             onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
//             style={{ width: '100%', paddingLeft: '2.25rem', paddingRight: '1rem', paddingTop: '0.5rem', paddingBottom: '0.5rem', backgroundColor: theme.muted, borderRadius: '0.5rem', border: `1px solid ${theme.border}`, outline: 'none', fontSize: '0.875rem', boxSizing: 'border-box' }}
//           />
//         </div>
//         <button style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', backgroundColor: theme.muted, border: `1px solid ${theme.border}`, fontSize: '0.875rem', borderRadius: '0.5rem', cursor: 'pointer', color: theme.foreground, width: isMobile ? '100%' : 'auto', justifyContent: 'center' }}>
//           <Filter style={{ width: '1rem', height: '1rem' }} /> Filter
//         </button>
//       </div>

//       {/* Data presentation container */}
//       <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', overflow: 'hidden', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
        
//         {/* Mobile View Layout (< md) */}
//         {isMobile && (
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             {currentItems.length > 0 ? (
//               currentItems.map((gst, idx) => (
//                 <div key={gst.id} style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', borderBottom: idx !== currentItems.length - 1 ? `1px solid ${theme.border}` : 'none' }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                     <div>
//                       <span style={{ backgroundColor: theme.muted, padding: '0.125rem 0.5rem', borderRadius: '0.25rem', fontFamily: 'monospace', fontSize: '0.75rem', fontWeight: 600 }}>{gst.id}</span>
//                       <h4 style={{ fontSize: '0.875rem', fontWeight: 'bold', color: theme.foreground, margin: '0.25rem 0 0 0' }}>{gst.name}</h4>
//                       <p style={{ fontSize: '0.75rem', color: theme.mutedForeground, margin: 0 }}>{gst.applicableOn}</p>
//                     </div>
//                     <span style={{ padding: '0.125rem 0.5rem', borderRadius: '0.25rem', fontSize: '0.75rem', backgroundColor: '#d1fae5', color: '#065f46', fontWeight: 500 }}>
//                       {gst.status}
//                     </span>
//                   </div>

//                   <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '0.5rem', backgroundColor: 'rgba(243, 244, 246, 0.4)', padding: '0.5rem', borderRadius: '0.5rem', border: `1px solid ${theme.border}`, textAlign: 'center', fontSize: '0.75rem' }}>
//                     <div>
//                       <p style={{ fontSize: '0.625rem', color: theme.mutedForeground, textTransform: 'uppercase', fontWeight: 600, margin: 0 }}>CGST</p>
//                       <p style={{ fontWeight: 'bold', color: theme.blue, margin: '0.125rem 0 0 0' }}>{gst.cgst}</p>
//                     </div>
//                     <div style={{ borderLeft: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}` }}>
//                       <p style={{ fontSize: '0.625rem', color: theme.mutedForeground, textTransform: 'uppercase', fontWeight: 600, margin: 0 }}>SGST</p>
//                       <p style={{ fontWeight: 'bold', color: theme.green, margin: '0.125rem 0 0 0' }}>{gst.sgst}</p>
//                     </div>
//                     <div>
//                       <p style={{ fontSize: '0.625rem', color: theme.mutedForeground, textTransform: 'uppercase', fontWeight: 600, margin: 0 }}>IGST</p>
//                       <p style={{ fontWeight: 'bold', color: theme.purple, margin: '0.125rem 0 0 0' }}>{gst.igst}</p>
//                     </div>
//                   </div>

//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '0.25rem', fontSize: '0.75rem', color: theme.mutedForeground }}>
//                     <span>{gst.createdDate}</span>
//                     <div style={{ display: 'flex', gap: '0.5rem' }}>
//                       <button onClick={() => handleOpenEdit(gst)} style={{ padding: '0.375rem', backgroundColor: theme.muted, border: 'none', borderRadius: '0.25rem', color: theme.foreground, cursor: 'pointer' }}>
//                         <Edit style={{ width: '0.875rem', height: '0.875rem' }} />
//                       </button>
//                       <button onClick={() => handleDelete(gst.id)} style={{ padding: '0.375rem', backgroundColor: theme.redBg, border: 'none', borderRadius: '0.25rem', color: theme.red, cursor: 'pointer' }}>
//                         <Trash2 style={{ width: '0.875rem', height: '0.875rem' }} />
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div style={{ padding: '2rem', textAlign: 'center', fontSize: '0.875rem', color: theme.mutedForeground }}>No records match your filters.</div>
//             )}
//           </div>
//         )}

//         {/* Desktop Table View Layout (>= md) */}
//         {!isMobile && (
//           <div style={{ overflowX: 'visible' }}>
//             <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
//               <thead>
//                 <tr style={{ backgroundColor: 'rgba(243, 244, 246, 0.5)', borderBottom: `1px solid ${theme.border}`, fontSize: '0.75rem', textTransform: 'uppercase', tracking: '0.05em', color: theme.mutedForeground }}>
//                   <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '12%' }}>GST ID</th>
//                   <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '24%' }}>Name</th>
//                   <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '15%', textAlign: 'center' }}>CGST (%)</th>
//                   <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '15%', textAlign: 'center' }}>SGST (%)</th>
//                   <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '15%', textAlign: 'center' }}>IGST (%)</th>
//                   <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '19%', textAlign: 'right' }}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody style={{ fontSize: '0.875rem' }}>
//                 {currentItems.length > 0 ? (
//                   currentItems.map((gst) => (
//                     <tr key={gst.id} style={{ borderBottom: `1px solid ${theme.border}`, transition: 'background-color 0.2s' }}>
//                       <td style={{ padding: '0.875rem 1rem', fontFamily: 'monospace', fontSize: '0.75rem', color: theme.mutedForeground }}>{gst.id}</td>
//                       <td style={{ padding: '0.875rem 1rem', fontWeight: 500, color: theme.foreground }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                           <Percent style={{ width: '1rem', height: '1rem', color: theme.primary, flexShrink: 0 }} />
//                           <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{gst.name}</span>
//                         </div>
//                       </td>
//                       <td style={{ padding: '0.875rem 1rem', textAlign: 'center', fontWeight: 'bold', color: theme.blue }}>{gst.cgst}</td>
//                       <td style={{ padding: '0.875rem 1rem', textAlign: 'center', fontWeight: 'bold', color: theme.green }}>{gst.sgst}</td>
//                       <td style={{ padding: '0.875rem 1rem', textAlign: 'center', fontWeight: 'bold', color: theme.purple }}>{gst.igst}</td>
//                       <td style={{ padding: '0.875rem 1rem', textAlign: 'right' }}>
//                         <div style={{ display: 'flex', gap: '0.25rem', justifyContent: 'flex-end' }}>
//                           <button onClick={() => handleOpenEdit(gst)} style={{ padding: '0.5rem', backgroundColor: 'transparent', border: 'none', borderRadius: '0.5rem', color: theme.mutedForeground, cursor: 'pointer' }}>
//                             <Edit style={{ width: '1rem', height: '1rem' }} />
//                           </button>
//                           <button onClick={() => handleDelete(gst.id)} style={{ padding: '0.5rem', backgroundColor: 'transparent', border: 'none', borderRadius: '0.5rem', color: theme.red, cursor: 'pointer' }}>
//                             <Trash2 style={{ width: '1rem', height: '1rem' }} />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="6" style={{ padding: '2rem', textAlign: 'center', fontSize: '0.875rem', color: theme.mutedForeground }}>No records match parameters.</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* Dynamic Pagination Footer */}
//         {totalPages > 0 && (
//           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem', borderTop: `1px solid ${theme.border}`, backgroundColor: theme.card, fontSize: '0.875rem' }}>
//             <span style={{ color: theme.mutedForeground, fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
//               Showing <span style={{ fontWeight: 600, color: theme.foreground }}>{indexOfFirstItem + 1}</span> to{' '}
//               <span style={{ fontWeight: 600, color: theme.foreground }}>
//                 {Math.min(indexOfLastItem, filteredData.length)}
//               </span>{' '}
//               of <span style={{ fontWeight: 600, color: theme.foreground }}>{filteredData.length}</span> items
//             </span>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
//               <button
//                 type="button"
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                 style={{ padding: '0.5rem', border: `1px solid ${theme.border}`, borderRadius: '0.5rem', backgroundColor: theme.muted, opacity: currentPage === 1 ? 0.5 : 1, cursor: currentPage === 1 ? 'not-allowed' : 'pointer', color: theme.foreground, display: 'flex', alignItems: 'center' }}
//               >
//                 <ChevronLeft style={{ width: '1rem', height: '1rem' }} />
//               </button>
              
//               {!isMobile && (
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
//                   {[...Array(totalPages)].map((_, idx) => (
//                     <button
//                       key={idx}
//                       type="button"
//                       onClick={() => setCurrentPage(idx + 1)}
//                       style={{ 
//                         padding: '0.375rem 0.75rem', 
//                         borderRadius: '0.5rem', 
//                         fontSize: '0.75rem', 
//                         fontWeight: 600, 
//                         border: '1px solid',
//                         cursor: 'pointer',
//                         backgroundColor: currentPage === idx + 1 ? theme.primary : 'transparent',
//                         color: currentPage === idx + 1 ? theme.primaryForeground : theme.foreground,
//                         borderColor: currentPage === idx + 1 ? theme.primary : theme.border
//                       }}
//                     >
//                       {idx + 1}
//                     </button>
//                   ))}
//                 </div>
//               )}

//               <button
//                 type="button"
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//                 style={{ padding: '0.5rem', border: `1px solid ${theme.border}`, borderRadius: '0.5rem', backgroundColor: theme.muted, opacity: currentPage === totalPages ? 0.5 : 1, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', color: theme.foreground, display: 'flex', alignItems: 'center' }}
//               >
//                 <ChevronRight style={{ width: '1rem', height: '1rem' }} />
//               </button>
//             </div>
//           </div>
//         )}

//       </div>

//       {/* CRUD Input Modal Sheet Overlay */}
//       {isOpen && (
//         <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', zIndex: 50 }}>
//           <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', width: '100%', maxWidth: '28rem', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', overflow: 'hidden' }}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyBetween: 'space-between', padding: '1rem', borderBottom: `1px solid ${theme.border}`, backgroundColor: theme.card, justifyContent: 'space-between' }}>
//               <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: theme.foreground, margin: 0 }}>
//                 {isEdit ? 'Edit GST Parameter' : 'Add New GST Configuration'}
//               </h2>
//               <button onClick={() => setIsOpen(false)} style={{ padding: '0.25rem', backgroundColor: 'transparent', border: 'none', borderRadius: '0.5rem', color: theme.foreground, cursor: 'pointer' }}>
//                 <X style={{ width: '1.25rem', height: '1.25rem' }} />
//               </button>
//             </div>

//             <form onSubmit={handleSave} style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '0.75rem' }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', color: theme.mutedForeground, marginBottom: '0.25rem' }}>CGST (%)</label>
//                   <input 
//                     type="number" step="0.01" placeholder="9" 
//                     value={cgst} onChange={(e) => setCgst(e.target.value)}
//                     style={{ width: '100%', padding: '0.5rem', backgroundColor: theme.muted, border: `1px solid ${theme.border}`, borderRadius: '0.5rem', fontSize: '0.875rem', outline: 'none', color: theme.foreground, boxSizing: 'border-box' }}
//                   />
//                 </div>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', color: theme.mutedForeground, marginBottom: '0.25rem' }}>SGST (%)</label>
//                   <input 
//                     type="number" step="0.01" placeholder="9" 
//                     value={sgst} onChange={(e) => setSgst(e.target.value)}
//                     style={{ width: '100%', padding: '0.5rem', backgroundColor: theme.muted, border: `1px solid ${theme.border}`, borderRadius: '0.5rem', fontSize: '0.875rem', outline: 'none', color: theme.foreground, boxSizing: 'border-box' }}
//                   />
//                 </div>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', color: theme.mutedForeground, marginBottom: '0.25rem' }}>IGST (%)</label>
//                   <input 
//                     type="number" step="0.01" placeholder="18" 
//                     value={igst} onChange={(e) => setIgst(e.target.value)}
//                     style={{ width: '100%', padding: '0.5rem', backgroundColor: theme.muted, border: `1px solid ${theme.border}`, borderRadius: '0.5rem', fontSize: '0.875rem', outline: 'none', color: theme.foreground, boxSizing: 'border-box' }}
//                   />
//                 </div>
//               </div>

//               <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', borderTop: `1px solid ${theme.border}`, paddingTop: '1rem', marginTop: '0.5rem' }}>
//                 <button type="button" onClick={() => setIsOpen(false)} style={{ px: '1rem', padding: '0.5rem 1rem', border: `1px solid ${theme.border}`, borderRadius: '0.5rem', fontSize: '0.875rem', color: theme.mutedForeground, backgroundColor: 'transparent', cursor: 'pointer' }}>Cancel</button>
//                 <button type="submit" style={{ padding: '0.5rem 1rem', backgroundColor: theme.primary, color: theme.primaryForeground, border: 'none', borderRadius: '0.5rem', fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer' }}>
//                   {isEdit ? 'Apply Changes' : 'Save Rate'}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
// export default MasterGst;


import React, { useState, useEffect } from "react";
import { FaFileInvoice, FaPencilAlt, FaTrash } from "react-icons/fa";

const MasterGst = () => {
  const [gstEntries, setGstEntries] = useState([]);
  const [form, setForm] = useState({ id: null, cgst: "", igst: "", sgst: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const API_BASE = "https://cloudapi.emedhatechnologies.com/pages/api/api/gst"; // ✅ Change to your backend port

  // ✅ Get user id from sessionStorage

  const user = JSON.parse(sessionStorage.getItem("userData"));
  const userId = user.type === "employee" ? user.parent_company_id : user.id;
  const currentUserId = user.id;

  // ✅ Fetch GST entries from backend
  useEffect(() => {
    if (!userId) return;
    fetch(API_BASE, {
      headers: {
        "x-user-id": userId,
      },
    })
      .then((res) => res.json())
      .then(setGstEntries)
      .catch((err) => console.error("Error fetching GST entries:", err));
  }, [userId]);

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
      setForm((prev) => ({ ...prev, [name]: value }));
      setError("");
    } else {
      setError("Values must be between 0 and 100");
    }
  };

  // ✅ Handle submit (Add / Update)
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId) {
      setError("User not logged in.");
      return;
    }

    // Basic validation
    if (!form.cgst || !form.sgst || !form.igst) {
      setError("All fields are required");
      return;
    }

    const method = isEditing ? "PUT" : "POST";
    const url = isEditing ? `${API_BASE}/${form.id}` : API_BASE;

    try {
      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          "x-user-id": userId,
          "x-user": currentUserId
        },
        body: JSON.stringify({
          cgst: Number(form.cgst),
          sgst: Number(form.sgst),
          igst: Number(form.igst),
        }),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || "Failed to save GST entry");
      }

      const data = await res.json();

      if (isEditing) {
        // Update locally
        setGstEntries((prev) =>
          prev.map((item) => (item.id === form.id ? data : item))
        );
        setIsEditing(false);
      } else {
        // Add new
        setGstEntries((prev) => [...prev, data]);
      }

      setForm({ id: null, cgst: "", sgst: "", igst: "" });
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };

  // ✅ Handle edit
  const handleEdit = (id) => {
    const entry = gstEntries.find((item) => item.id === id);
    if (entry) {
      setForm(entry);
      setIsEditing(true);
    }
  };

  // ✅ Handle delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this entry?")) return;

    try {
      const res = await fetch(`${API_BASE}/${id}`, {
        method: "DELETE",
        headers: {
          "x-user-id": userId,
        },
      });

      if (!res.ok) throw new Error("Failed to delete GST entry");

      setGstEntries((prev) => prev.filter((item) => item.id !== id));

      if (isEditing && form.id === id) {
        setForm({ id: null, cgst: "", sgst: "", igst: "" });
        setIsEditing(false);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // --- Design System State Variables & Handlers Needed below for the new layout ---
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const isTablet = windowWidth < 1024;

  const theme = {
    background: "#f9fafb",
    foreground: "#111827",
    card: "#ffffff",
    border: "#e5e7eb",
    muted: "#f3f4f6",
    mutedForeground: "#6b7280",
    primary: "#273179",
    primaryForeground: "#ffffff",
    blue: "#2563eb",
    green: '#16a34a',
    purple: '#9333ea',
    red: '#ef4444',
    redBg: '#fef2f2'
  };

  const filteredData = gstEntries.filter(item => {
    const searchString = searchTerm.toLowerCase();
    return (
      (item.id && String(item.id).toLowerCase().includes(searchString)) ||
      (item.cgst && String(item.cgst).includes(searchString)) ||
      (item.sgst && String(item.sgst).includes(searchString)) ||
      (item.igst && String(item.igst).includes(searchString))
    );
  });

  return (
    <div style={{ padding: isTablet ? '1rem' : '2rem', display: 'flex', flexDirection: 'column', gap: '1.5rem', backgroundColor: theme.background, minHeight: '100vh', color: theme.foreground, fontFamily: 'sans-serif' }}>
      
      {/* Header section */}
      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'space-between', gap: '1rem' }}>
        <div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', letterSpacing: '-0.025em', margin: 0, color: theme.primary, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <FaFileInvoice /> Master GST
          </h1>
          <p style={{ color: theme.mutedForeground, fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>Manage GST rates and configurations securely</p>
        </div>
        <button 
          onClick={() => {
            setForm({ id: null, cgst: "", sgst: "", igst: "" });
            setIsEditing(false);
            setIsOpen(true);
          }}
          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', backgroundColor: theme.primary, color: theme.primaryForeground, border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontSize: '0.875rem', width: isMobile ? '100%' : 'auto', justifyContent: 'center', fontWeight: '600' }}
        >
          + Add GST Rate
        </button>
      </div>

      {/* Stats Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, minmax(0, 1fr))' : isTablet ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))', gap: '1rem' }}>
        <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
          <p style={{ color: theme.mutedForeground, fontSize: '0.75rem', fontWeight: 500, textTransform: 'uppercase', margin: '0 0 0.25rem 0' }}>Total configurations</p>
          <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>{gstEntries.length}</h3>
        </div>
        <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
          <p style={{ color: theme.mutedForeground, fontSize: '0.75rem', fontWeight: 500, textTransform: 'uppercase', margin: '0 0 0.25rem 0' }}>Active CGST entries</p>
          <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0, color: theme.blue }}>{gstEntries.filter(i => parseFloat(i.cgst) > 0).length}</h3>
        </div>
        <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
          <p style={{ color: theme.mutedForeground, fontSize: '0.75rem', fontWeight: 500, textTransform: 'uppercase', margin: '0 0 0.25rem 0' }}>Active SGST entries</p>
          <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0, color: theme.green }}>{gstEntries.filter(i => parseFloat(i.sgst) > 0).length}</h3>
        </div>
        <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
          <p style={{ color: theme.mutedForeground, fontSize: '0.75rem', fontWeight: 500, textTransform: 'uppercase', margin: '0 0 0.25rem 0' }}>Active IGST entries</p>
          <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0, color: theme.purple }}>{gstEntries.filter(i => parseFloat(i.igst) > 0).length}</h3>
        </div>
      </div>

      {/* Filters search row */}
      <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', padding: '1rem', display: 'flex', flexDirection: 'row', gap: '0.75rem', alignItems: 'center' }}>
        <div style={{ flex: 1, width: '100%', position: 'relative' }}>
          <input
            type="text"
            placeholder="Search GST configurations..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: '100%', paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.5rem', paddingBottom: '0.5rem', backgroundColor: theme.muted, borderRadius: '0.5rem', border: `1px solid ${theme.border}`, outline: 'none', fontSize: '0.875rem', boxSizing: 'border-box' }}
          />
        </div>
      </div>

      {error && (
        <div style={{ padding: '0.75rem', backgroundColor: theme.redBg, border: `1px solid ${theme.red}`, color: theme.red, borderRadius: '0.5rem', fontSize: '0.875rem', textAlign: 'center' }}>
          {error}
        </div>
      )}

      {/* Data presentation container */}
      <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', overflow: 'hidden', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
        
        {/* Mobile View Layout (< md) */}
        {isMobile && (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {filteredData.length > 0 ? (
              filteredData.map((gst, idx) => (
                <div key={gst.id || idx} style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '0.75rem', borderBottom: idx !== filteredData.length - 1 ? `1px solid ${theme.border}` : 'none' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <span style={{ backgroundColor: theme.muted, padding: '0.125rem 0.5rem', borderRadius: '0.25rem', fontFamily: 'monospace', fontSize: '0.75rem', fontWeight: 600 }}>ID: {gst.id || "N/A"}</span>
                      <h4 style={{ fontSize: '0.875rem', fontWeight: 'bold', color: theme.foreground, margin: '0.25rem 0 0 0' }}>GST Slab Matrix</h4>
                    </div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '0.5rem', backgroundColor: 'rgba(243, 244, 246, 0.4)', padding: '0.5rem', borderRadius: '0.5rem', border: `1px solid ${theme.border}`, textAlign: 'center', fontSize: '0.75rem' }}>
                    <div>
                      <p style={{ fontSize: '0.625rem', color: theme.mutedForeground, textTransform: 'uppercase', fontWeight: 600, margin: 0 }}>CGST</p>
                      <p style={{ fontWeight: 'bold', color: theme.blue, margin: '0.125rem 0 0 0' }}>{parseFloat(gst.cgst).toFixed(2)}%</p>
                    </div>
                    <div style={{ borderLeft: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}` }}>
                      <p style={{ fontSize: '0.625rem', color: theme.mutedForeground, textTransform: 'uppercase', fontWeight: 600, margin: 0 }}>SGST</p>
                      <p style={{ fontWeight: 'bold', color: theme.green, margin: '0.125rem 0 0 0' }}>{parseFloat(gst.sgst).toFixed(2)}%</p>
                    </div>
                    <div>
                      <p style={{ fontSize: '0.625rem', color: theme.mutedForeground, textTransform: 'uppercase', fontWeight: 600, margin: 0 }}>IGST</p>
                      <p style={{ fontWeight: 'bold', color: theme.purple, margin: '0.125rem 0 0 0' }}>{parseFloat(gst.igst).toFixed(2)}%</p>
                    </div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingTop: '0.25rem' }}>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <button onClick={() => { handleEdit(gst.id); setIsOpen(true); }} style={{ padding: '0.375rem 0.75rem', backgroundColor: theme.muted, border: 'none', borderRadius: '0.25rem', color: theme.foreground, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.75rem' }}>
                        <FaPencilAlt /> Edit
                      </button>
                      <button onClick={() => handleDelete(gst.id)} style={{ padding: '0.375rem 0.75rem', backgroundColor: theme.redBg, border: 'none', borderRadius: '0.25rem', color: theme.red, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.75rem' }}>
                        <FaTrash /> Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ padding: '2rem', textAlign: 'center', fontSize: '0.875rem', color: theme.mutedForeground }}>No records match your filters.</div>
            )}
          </div>
        )}

        {/* Desktop Table View Layout (>= md) */}
        {!isMobile && (
          <div style={{ overflowX: 'visible' }}>
            <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
              <thead>
                <tr style={{ backgroundColor: 'rgba(243, 244, 246, 0.5)', borderBottom: `1px solid ${theme.border}`, fontSize: '0.75rem', textTransform: 'uppercase', color: theme.mutedForeground }}>
                  <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '15%' }}>GST ID</th>
                  <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '20%', textAlign: 'center' }}>CGST (%)</th>
                  <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '20%', textAlign: 'center' }}>SGST (%)</th>
                  <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '20%', textAlign: 'center' }}>IGST (%)</th>
                  <th style={{ padding: '0.75rem 1rem', fontWeight: 600, width: '25%', textAlign: 'right' }}>Actions</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: '0.875rem' }}>
                {filteredData.length > 0 ? (
                  filteredData.map((gst) => (
                    <tr key={gst.id} style={{ borderBottom: `1px solid ${theme.border}` }}>
                      <td style={{ padding: '0.875rem 1rem', fontFamily: 'monospace', fontSize: '0.75rem', color: theme.mutedForeground }}>{gst.id || "N/A"}</td>
                      <td style={{ padding: '0.875rem 1rem', textAlign: 'center', fontWeight: 'bold', color: theme.blue }}>{parseFloat(gst.cgst).toFixed(2)}%</td>
                      <td style={{ padding: '0.875rem 1rem', textAlign: 'center', fontWeight: 'bold', color: theme.green }}>{parseFloat(gst.sgst).toFixed(2)}%</td>
                      <td style={{ padding: '0.875rem 1rem', textAlign: 'center', fontWeight: 'bold', color: theme.purple }}>{parseFloat(gst.igst).toFixed(2)}%</td>
                      <td style={{ padding: '0.875rem 1rem', textAlign: 'right' }}>
                        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                          <button onClick={() => { handleEdit(gst.id); setIsOpen(true); }} style={{ padding: '0.375rem 0.75rem', backgroundColor: theme.muted, border: 'none', borderRadius: '0.375rem', color: theme.foreground, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.375rem', fontSize: '0.75rem' }}>
                            <FaPencilAlt /> Edit
                          </button>
                          <button onClick={() => handleDelete(gst.id)} style={{ padding: '0.375rem 0.75rem', backgroundColor: theme.redBg, border: 'none', borderRadius: '0.375rem', color: theme.red, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.375rem', fontSize: '0.75rem' }}>
                            <FaTrash /> Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ padding: '2rem', textAlign: 'center', fontSize: '0.875rem', color: theme.mutedForeground }}>No records match parameters.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* CRUD Overlay Form Modal Block */}
      {isOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', zIndex: 50 }}>
          <div style={{ backgroundColor: theme.card, border: `1px solid ${theme.border}`, borderRadius: '0.75rem', width: '100%', maxWidth: '28rem', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', overflow: 'hidden' }}>
            <div style={{ display: 'flex', alignItems: 'center', padding: '1rem', borderBottom: `1px solid ${theme.border}`, backgroundColor: theme.card, justifyContent: 'space-between' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: theme.primary, margin: 0 }}>
                {isEditing ? 'Edit GST Parameter' : 'Add New GST Configuration'}
              </h2>
              <button onClick={() => setIsOpen(false)} style={{ padding: '0.25rem', backgroundColor: 'transparent', border: 'none', borderRadius: '0.5rem', color: theme.foreground, cursor: 'pointer', fontSize: '1.25rem', fontWeight: 'bold' }}>
                &times;
              </button>
            </div>

            <form onSubmit={(e) => { handleSubmit(e); if(form.cgst && form.sgst && form.igst && !error) setIsOpen(false); }} style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }} noValidate>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {["cgst", "sgst", "igst"].map((tax) => (
                  <div key={tax}>
                    <label htmlFor={tax} style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', color: theme.mutedForeground, marginBottom: '0.25rem' }}>
                      {tax.toUpperCase()} (%)
                    </label>
                    <input 
                      type="number" 
                      id={tax}
                      name={tax} 
                      placeholder={`Enter ${tax.toUpperCase()} %`} 
                      value={form[tax]} 
                      onChange={handleChange}
                      style={{ width: '100%', padding: '0.5rem', backgroundColor: theme.muted, border: `1px solid ${theme.border}`, borderRadius: '0.5rem', fontSize: '0.875rem', outline: 'none', color: theme.foreground, boxSizing: 'border-box' }}
                    />
                  </div>
                ))}
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', borderTop: `1px solid ${theme.border}`, paddingTop: '1rem', marginTop: '0.5rem' }}>
                <button type="button" onClick={() => setIsOpen(false)} style={{ padding: '0.5rem 1rem', border: `1px solid ${theme.border}`, borderRadius: '0.5rem', fontSize: '0.875rem', color: theme.mutedForeground, backgroundColor: 'transparent', cursor: 'pointer' }}>Cancel</button>
                <button type="submit" style={{ padding: '0.5rem 1rem', backgroundColor: isEditing ? "#E53E3E" : theme.primary, color: theme.primaryForeground, border: 'none', borderRadius: '0.5rem', fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer' }}>
                  {isEditing ? 'Apply Changes' : 'Save Rate'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default MasterGst;